import React from "react";

const benefits = [
  "No upfront payments",
  "Getting your activity online takes under 30 minutes",
  "Fixed commission on successful bookings",
];

function HomeWhySection() {
  const handleGetStarted = () => {};
  return (
    <div className={Classname.container}>
      <div className={Classname.content}>
        <span className="font-bold text-2xl lg:text-4xl text-center">
          Why sell on Nobii
        </span>
        <p className="text-center max-w-4xl mt-2 mb-10 text-sm lg:text-base">
          {`Connect with travelers looking for exactly the kind of experience you
          offer by signing up today.You’ll receive access to our marketing
          channels, expansive blogger network, and in-house marketplace to take
          your reach even further.`}
        </p>
        <div className="bg-[#EBEFF959] py-10 px-4 lg:px-10 gap-10 rounded-md flex flex-col lg:flex-row justify-between mb-20">
          <div className={Classname.why}>
            <div className={Classname.title}>
              Earn more from our high monthly traffic
            </div>
            <div className={Classname.description}>
              Bring your travel business to millions of worldwide travellers
              visiting Nobii or partner sites each month.
            </div>
          </div>
          <div className={Classname.why}>
            <div className={Classname.title}>Instant application review</div>
            <div className={Classname.description}>
              Upon signup, your application is instantly reviewed. If approved,
              you'll receive an email notification with your commission level.
            </div>
          </div>
          <div className={Classname.why}>
            <div className={Classname.title}>Streamlined Payments</div>
            <div className={Classname.description}>
              Client payments are consolidated and disbursed to you weekly,
              bi-weekly or monthly.
            </div>
            <div className={Classname.description}>
              Focus on your business as we manage bookings and provide full
              customer support.
            </div>
          </div>
        </div>

        <div className="w-full flex items-center justify-center mb-10">
          <button
            className="h-14 w-80 bg-primary rounded-md flex items-center justify-center text-white text-sm lg:text-base font-bold"
            onClick={handleGetStarted}
          >
            Get Started
          </button>
        </div>

        <ul className="flex flex-col lg:flex-row gap-2 lg:gap-10 object-center list-disc text-sm mb-20 px-2">
          {benefits.map((benefit, index) => (
            <li className="" key={index}>
              {benefit}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default HomeWhySection;

const Classname = {
  container:
    "w-full flex justify-center pt-20 px-basicx xl:px-0 font-main relative",
  content: "w-full flex flex-col max-w-7xl px-2 xl:px-0 items-center",
  title:
    "text-primary text-lg lg:text-xl font-bold  text-center lg:text-start max-w-56",
  description: "text-sm lg:text-base text-center lg:text-start",
  why: "flex flex-1 flex-col gap-4 items-center lg:items-start",
};
